export default "__VITE_ASSET__ylSckYDa__"